import { supabase } from "@/lib/supabase";

// ---------- Public reads ----------
export async function listPlayers(sport) {
  let q = supabase.from("players").select("*").order("order", { ascending: true });
  if (sport) q = q.eq("sport", sport);
  const { data } = await q;
  return data || [];
}

export async function listStaff(sport) {
  let q = supabase.from("staff").select("*").order("order", { ascending: true });
  if (sport) q = q.eq("sport", sport);
  const { data } = await q;
  return data || [];
}

export async function listNews() {
  const { data } = await supabase.from("news").select("*").order("date", { ascending: false });
  return data || [];
}

export async function getNews(id) {
  const { data, error } = await supabase.from("news").select("*").eq("id", id).single();
  if (error) throw error;
  return data;
}

export async function listMatches(sport) {
  let q = supabase.from("matches").select("*").eq("completed", false).order("date", { ascending: true });
  if (sport) q = q.eq("sport", sport);
  const { data } = await q;
  return data || [];
}

export async function listResults(sport) {
  let q = supabase.from("matches").select("*").eq("completed", true).order("date", { ascending: false });
  if (sport) q = q.eq("sport", sport);
  const { data } = await q;
  return data || [];
}

export async function listPartners() {
  const { data } = await supabase.from("partners").select("*").order("order", { ascending: true });
  return data || [];
}

export async function listCompetitions() {
  const { data } = await supabase.from("competitions").select("*").order("order", { ascending: true });
  return data || [];
}

const ADMIN_ORDER = {
  players: ["order", true], staff: ["order", true], partners: ["order", true],
  competitions: ["order", true],
  news: ["date", false], matches: ["date", true],
};
export async function listItems(table) {
  const [col, asc] = ADMIN_ORDER[table] || ["id", true];
  const { data } = await supabase.from(table).select("*").order(col, { ascending: asc });
  return data || [];
}

export async function getStats() {
  const { data } = await supabase.from("stats").select("*").eq("id", 1).single();
  return data || { years: 0, athletes: 0, titles: 0, departments: 0 };
}

export async function getSettings() {
  const { data } = await supabase.from("settings").select("*").eq("id", 1).single();
  return data || {};
}

// ---------- Admin mutations ----------
export async function createItem(table, payload) {
  const { data, error } = await supabase.from(table).insert(payload).select().single();
  if (error) throw error;
  return data;
}

export async function updateItem(table, id, payload) {
  const clean = { ...payload };
  delete clean.id;
  const { data, error } = await supabase.from(table).update(clean).eq("id", id).select().single();
  if (error) throw error;
  return data;
}

export async function deleteItem(table, id) {
  const { error } = await supabase.from(table).delete().eq("id", id);
  if (error) throw error;
}

export async function updateStats(payload) {
  const { error } = await supabase.from("stats").update(payload).eq("id", 1);
  if (error) throw error;
}

export async function updateSettings(payload) {
  const clean = { ...payload };
  delete clean.id;
  const { error } = await supabase.from("settings").update(clean).eq("id", 1);
  if (error) throw error;
}

export async function listMessages() {
  const { data } = await supabase.from("messages").select("*").order("created_at", { ascending: false });
  return data || [];
}

export async function deleteMessage(id) {
  const { error } = await supabase.from("messages").delete().eq("id", id);
  if (error) throw error;
}

// ---------- Contact + email ----------
export async function submitContact(payload) {
  const { error } = await supabase.from("messages").insert(payload);
  if (error) throw error;
  try {
    await supabase.functions.invoke("send-contact-email", { body: payload });
  } catch (e) {
    // email is best-effort; message already stored
  }
  return true;
}

// ---------- Image upload (Storage) ----------
export async function uploadImage(file) {
  const ext = file.name.includes(".") ? file.name.split(".").pop() : "png";
  const path = `uploads/${crypto.randomUUID()}.${ext}`;
  const { error } = await supabase.storage.from("media").upload(path, file, {
    upsert: false,
    contentType: file.type || "image/png",
  });
  if (error) throw error;
  const { data } = supabase.storage.from("media").getPublicUrl(path);
  return data.publicUrl;
}

// ---------- AI article optimization (Supabase Edge Function + Gemini) ----------
export async function optimizeArticle(text, title = "") {
  const { data, error } = await supabase.functions.invoke("optimize-article", {
    body: { text, title },
  });
  if (error) throw error;
  return data?.content || "";
}
